import { connect } from 'react-redux';

import { detectMobileDevice } from '../../../../util/detectBrowser';
import { hideModal } from '../../../../actions/ModalActions';
import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';
import { getChecklistTaskById } from '../../../../selectors/checklist/checklistSelectors';

import ChecklistDeleteTaskModal from './ChecklistDeleteTaskModal';

const mapStateToProps = (state, ownProps) => {
  const { taskId } = ownProps;
  const task = getChecklistTaskById(state, taskId);

  return {
    taskTitle: task.title,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onDelete: () => {
    const { taskId } = ownProps;

    if (!taskId) return Promise.resolve();

    return dispatch(checklistV2Actions.deleteTask(taskId)).then(() => {
      const isMobile = detectMobileDevice();
      dispatch(hideModal());

      if (ownProps.callback) ownProps.callback();

      if (!isMobile) {
        dispatch(checklistV2Actions.handleNavigatingAfterDelete(taskId));
      } else {
        dispatch(checklistV2Actions.handleMobileClose());
      }

      return dispatch(checklistV2Actions.filterTasks(false));
    });
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistDeleteTaskModal);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistDeleteTaskModal/index.js